import { useBrand } from '@/branding/BrandContext';
import { useTranslation } from '@/lib/i18n';

export function Footer() {
  const brand = useBrand();
  const { t } = useTranslation();
  return (
    <footer
      className="px-4 py-3 text-center text-[10px] tracking-wider"
      style={{ background: 'var(--brand-navy,#0A1128)', color: 'rgba(255,255,255,0.85)' }}
    >
      {brand.name} · {t('footer.copyright')}
    </footer>
  );
}
